'use strict';
import * as $j_com$002eraquo$002elaminar$002emodifiers$002e$002dRenderable$002dNode$0024$0024anon$00241 from "./com.raquo.laminar.modifiers.-Renderable-Node$$anon$1.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_RenderableNode$() {
  this.bb = null;
  $n_Lcom_raquo_laminar_modifiers_RenderableNode$ = this;
  this.bb = new $j_com$002eraquo$002elaminar$002emodifiers$002e$002dRenderable$002dNode$0024$0024anon$00241.$c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1();
}
export { $c_Lcom_raquo_laminar_modifiers_RenderableNode$ as $c_Lcom_raquo_laminar_modifiers_RenderableNode$ };
$p = $c_Lcom_raquo_laminar_modifiers_RenderableNode$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_modifiers_RenderableNode$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_RenderableNode$() {
}
export { $h_Lcom_raquo_laminar_modifiers_RenderableNode$ as $h_Lcom_raquo_laminar_modifiers_RenderableNode$ };
$h_Lcom_raquo_laminar_modifiers_RenderableNode$.prototype = $p;
var $d_Lcom_raquo_laminar_modifiers_RenderableNode$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_modifiers_RenderableNode$, "com.raquo.laminar.modifiers.RenderableNode$", ({
  iA: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_RenderableNode$ as $d_Lcom_raquo_laminar_modifiers_RenderableNode$ };
var $n_Lcom_raquo_laminar_modifiers_RenderableNode$;
function $m_Lcom_raquo_laminar_modifiers_RenderableNode$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_RenderableNode$)) {
    $n_Lcom_raquo_laminar_modifiers_RenderableNode$ = new $c_Lcom_raquo_laminar_modifiers_RenderableNode$();
  }
  return $n_Lcom_raquo_laminar_modifiers_RenderableNode$;
}
export { $m_Lcom_raquo_laminar_modifiers_RenderableNode$ as $m_Lcom_raquo_laminar_modifiers_RenderableNode$ };
